import { render, staticRenderFns } from "./MultiDragImg.vue?vue&type=template&id=986203c4&"
import script from "./MultiDragImg.vue?vue&type=script&lang=js&"
export * from "./MultiDragImg.vue?vue&type=script&lang=js&"
import style0 from "./MultiDragImg.vue?vue&type=style&index=0&id=986203c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports